import { useState, type FormEvent } from "react";
import { AuthLayout, type VersionInfo } from "@/components/Brand";
import { ErrorAlert } from "@/components/ErrorAlert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errorText, setPassword } from "@/lib/client";
import { MIN_LENGTH, checkNewPassword } from "@/lib/password";

export function SetPasswordScreen({ onDone, onLogout, company, version }: { company?: string | null; version?: VersionInfo | null; onDone: () => void; onLogout: () => void }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    const newPassword = String(f.get("newPassword"));
    const newPasswordConfirm = String(f.get("newPasswordConfirm"));
    const local = checkNewPassword(newPassword, newPasswordConfirm);
    if (local) return setError(local);
    setBusy(true);
    setError("");
    try {
      await setPassword({ newPassword, newPasswordConfirm });
      onDone();
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  }

  return (
    <AuthLayout company={company} version={version}>
      <h1 className="text-2xl font-semibold tracking-tight">Parola belirleme</h1>
      <p className="text-sm text-muted-foreground">
        Geçici parolayla girdiniz. Devam etmek için yeni parolanızı belirleyin: en az {MIN_LENGTH} karakter, geçici paroladan farklı.
      </p>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="newPassword">Yeni parola</Label>
          <Input id="newPassword" name="newPassword" type="password" autoComplete="new-password" required autoFocus aria-invalid={error ? true : undefined} aria-describedby={error ? "set-password-err" : undefined} />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="newPasswordConfirm">Yeni parola (tekrar)</Label>
          <Input id="newPasswordConfirm" name="newPasswordConfirm" type="password" autoComplete="new-password" required aria-invalid={error ? true : undefined} aria-describedby={error ? "set-password-err" : undefined} />
        </div>
        {error && <div id="set-password-err"><ErrorAlert>{error}</ErrorAlert></div>}
        <Button type="submit" disabled={busy}>{busy ? "Kaydediliyor…" : "Parolayı belirle"}</Button>
        <Button type="button" variant="ghost" onClick={onLogout}>Çıkış</Button>
      </form>
    </AuthLayout>
  );
}
